<nav class="navbar navbar-dark border-bottom">
  <div class="container-fluid d-flex align-items-center" style="height: 60px;">

    <!-- Logo placeholder -->
    <a routerLink="/" class="navbar-brand d-flex align-items-center text-decoration-none">
      <img src="assets/logo.png" alt="Logo" height="50">
      <span class="fw-bold ms-3">CMS</span>
      <span class="badge fw-bold ms-3 bg-danger"*ngIf="isStaging">STAGING</span>
    </a>

    <div class="flex-grow-1"></div>

    <!-- Search -->
    <div *ngIf="!isSmall && loggedIn" class="mx-3" style="width: 400px;">
      <app-searchbar searchType="Cases"></app-searchbar>
    </div>

    <!-- Recent Cases -->
    <div *ngIf="loggedIn" ngbDropdown #dropdown="ngbDropdown">
      <button class="btn btn-link text-decoration-none text-white"
              type="button"
              ngbDropdownToggle
              (click)="loadRecentCases()">
        Recent Cases
      </button>
      <div ngbDropdownMenu style="min-width: 500px;">

      <div *ngIf="!recentCasesLoaded" class="d-flex justify-content-center py-4">
          <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <table class="table table-sm table-hover mb-0 small" *ngIf="recentCasesLoaded">
          <thead>
            <tr class="text-muted">
              <th style="width: 25%;">Case Ref</th>
              <th style="width: 45%;">Client</th>
              <th style="width: 30%;">Type</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let case of recentCases"
                [routerLink]="['case', case.caseId]"
                (click)="dropdown.close()"
                style="cursor: pointer;">
              <td class="text-truncate">{{case.caseReference}}</td>
              <td class="text-truncate">{{case.partyOneFullName}}</td>
              <td class="text-truncate">{{case.typeName}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="flex-grow-1"></div>

    <!-- Notifications + User -->
    <div *ngIf="loggedIn" class="d-flex align-items-center gap-2">
      <button type="button" class="btn btn-link text-white p-1" (click)="openNotifications()">
        <fa-icon [icon]="faBell" size="lg" *ngIf="!unacknowledgedNotifications"></fa-icon>
        <fa-icon [icon]="faBellOn" size="lg" *ngIf="unacknowledgedNotifications" class="text-danger"></fa-icon>
      </button>
      <span class="fw-semibold fst-italic ms-2">{{authService.getName()}}</span>
      <button type="button" class="btn btn-link text-white p-1" (click)="authService.logout()" ngbTooltip="Log Out">
        <fa-icon [icon]="faSignOut"></fa-icon>
      </button>
    </div>

  </div>
</nav>

<app-notifications *ngIf="showNotifications" (closeNotifications)="closeNotifications()"></app-notifications>